import { apiClient } from './api';

interface CheckoutInfo {
  customer_email: string;
  product_name: string;
  amount_total: number;
  currency: string;
  account_exists: boolean;
  has_course: boolean;
  already_claimed: boolean;
}

interface WelcomeClaimResponse {
  product_name: string;
  has_course: boolean;
  customer_link_id: number;
}

export const stripeService = {
  /**
   * Get purchase context for the welcome page.
   * Accepts either session_id or token.
   * GET /api/stripe/checkout-info/
   */
  async getCheckoutInfo(params: { session_id?: string; token?: string }): Promise<CheckoutInfo> {
    const searchParams = new URLSearchParams();
    if (params.session_id) searchParams.set('session_id', params.session_id);
    if (params.token) searchParams.set('token', params.token);
    return apiClient.get<CheckoutInfo>(`/api/stripe/checkout-info/?${searchParams}`);
  },

  /**
   * Link Stripe customer to authenticated user.
   * Accepts either session_id or token.
   * POST /api/stripe/welcome-claim/
   */
  async welcomeClaim(params: { session_id?: string; token?: string }): Promise<WelcomeClaimResponse> {
    return apiClient.post<WelcomeClaimResponse>('/api/stripe/welcome-claim/', params);
  },
};
